import { BaseConfig } from '../ServiceConfig';

export interface SearchConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.SearchServiceConfigData';
  url: string;
  token: string;
  channel: string;
  terminal: string;
}

export const SearchConfigurationFields: (keyof SearchConfiguration)[] = [
  'url',
  'token',
  'channel',
  'terminal',
];

export const BlankSearchConfiguration: SearchConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.SearchServiceConfigData',
} as SearchConfiguration;
